import { defineStore } from "pinia";
import { watch } from "vue";

export const useUIStore = defineStore("UIStore", {
  state: () => ({
    is_dark_mode: localStorage.getItem("is_dark_mode") === "true" || false,
    alert_list: [],
    is_loading: false,
    is_change_investment_loading: false,
    is_chart_loading: false,
    removal_timer: null,
    sort_header: {
      field_name: "created_date",
      ascending: false,
    },
    breadCrumbs: [],
  }),
  getters: {},
  actions: {
    toggleDarkMode() {
      this.is_dark_mode = !this.is_dark_mode;
    },
    setupAlertWatcher() {
      watch(
        () => this.alert_list,
        () => {
          const nonPersistentAlerts = this.alert_list.filter((alert) => !alert.does_persist);

          // If there are non-persistent alerts, schedule their removal
          if (nonPersistentAlerts.length > 0) {
            this.scheduleAlertRemoval(nonPersistentAlerts);
          }
        },
        { deep: true }
      );
    },
    scheduleAlertRemoval(alerts) {
      // Cancel any existing removal timer
      clearTimeout(this.removal_timer);

      this.removal_timer = setTimeout(() => {
        // Start removing alerts, last to first
        for (let i = alerts.length - 1; i >= 0; i--) {
          setTimeout(
            () => {
              this.removeNotification(alerts[i].id);
            },
            (alerts.length - 1 - i) * 500
          ); // 500ms-second stagger
        }
      }, 3000); // 3-second delay before starting removal
    },
    removeNotification(id) {
      const alertIndex = this.alert_list.findIndex((alert) => alert.id === id);
      if (alertIndex !== -1) {
        this.alert_list[alertIndex].show = false;
      }

      setTimeout(() => {
        this.alert_list = this.alert_list.filter((alert) => alert.id !== id);
      }, 200);
    },
    async animateNotificationAlert(doc) {
      const {
        type = "success",
        message = "Default Message For Notification",
        subText = "",
        is_read = false,
        does_persist = false,
        action = null,
        icon = "",
      } = doc;

      const alert_notification = {
        type,
        message,
        subText,
        is_read,
        does_persist,
        action,
        id: Date.now(),
        show: false,
        icon,
      };
      this.alert_list.push(alert_notification);

      // This is to get the animation to work as expected
      setTimeout(() => {
        const index = this.alert_list.findIndex((alert) => alert.id === alert_notification.id);
        if (index !== -1) {
          this.alert_list[index].show = true;
        }
      }, 0);
    },
    slugify(str = "") {
      return str
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // spaces → dashes
        .replace(/[^\w-]+/g, "") // remove non-word chars
        .replace(/--+/g, "-"); // collapse dashes
    },
    daysUntilDate(targetDate) {
      const currentDate = new Date();
      const target = new Date(targetDate);
      const timeDiff = target - currentDate;
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return daysDiff >= 0 ? daysDiff : 0;
    },
    daysSinceDate(pastDate) {
      const currentDate = new Date();
      const past = new Date(pastDate);
      const timeDiff = currentDate - past;
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return daysDiff >= 0 ? daysDiff : 0;
    },
  },
});
